/* Afich GA4: explicit business events, shared consent/context across the Shopify iframe boundary. */
(function () {
  'use strict';
  if (window.AfichAnalytics) return;
  var MID = 'G-S4RPXTPRSL', VERSION = '20260929';
  // This GA4 stream is a destination of the existing Shopify Google tag.
  // Its /gtag/js URL returns 404; the shared tag bootstrap and GA4 destination both return 200.
  var GOOGLE_TAG_LOADER = 'AW-17095533217';
  var trusted = ['https://afich.com', 'https://www.afich.com', 'https://edition.afich.com'];
  var embedded = window.parent !== window, parentOrigin = '';
  try { parentOrigin = new URL(document.referrer).origin; } catch (e) {}
  var surface = window.__afichSurface || (location.pathname === '/atelier.html' ? 'atelier' :
    location.hostname === 'edition.afich.com' || !window.Shopify ? 'creator' :
    /studio/.test(location.pathname) ? 'shopify_studio' : location.pathname.indexOf('/products/')===0 ? 'shopify_product' : 'shopify_site');
  var allowed = false, clientId = '', sessionId = '', tagStarted = false, queue = [], frames = [];
  var mode = 'edit', step = '', creationId = '', parentNonce = uuid();
  var personalizedPage = new URLSearchParams(location.search).has('afich_design');
  var nativeFetch = window.fetch.bind(window), started = Date.now();
  var events = new Set([
    'afich_world_banner_view', 'afich_world_banner_click', 'afich_world_view', 'afich_world_place', 'afich_world_search', 'afich_world_product', 'afich_world_empty',
    'afich_gift_banner_view', 'afich_gift_open', 'afich_gift_close', 'afich_gift_spin', 'afich_gift_won', 'afich_gift_form_start', 'afich_gift_optin', 'afich_gift_code_request', 'afich_gift_code_sent', 'afich_gift_email_return', 'afich_gift_code_copy', 'afich_gift_discount_applied', 'afich_gift_cart_added', 'afich_gift_checkout', 'afich_gift_error',
    'afich_surface_viewed', 'afich_step_viewed', 'afich_mode_selected', 'afich_photos_added',
    'afich_generation_requested', 'afich_result_viewed', 'afich_edit_requested',
    'afich_edit_result_viewed', 'afich_version_selected', 'afich_design_validated',
    'afich_editor_opened', 'afich_editor_closed', 'afich_creation_restarted',
    'afich_cart_added', 'afich_cart_error', 'afich_checkout_clicked',
    'afich_quota_reached', 'afich_error', 'afich_suggestion_selected', 'afich_edit_point_added',
    'afich_form_started', 'afich_page_hidden', 'afich_creation_saved', 'afich_gallery_opened',
    'afich_project_resumed', 'afich_clarification_answered', 'afich_tutorial_viewed', 'afich_tutorial_dismissed',
  ]);
  var fields = new Set(['surface', 'step', 'creation_mode', 'creation_id', 'photo_count', 'image_count',
    'version_index', 'edit_count', 'duration_ms', 'error_code', 'http_status', 'operation',
    'item_count', 'product_variant', 'ai_model', 'image_quality', 'remaining', 'entry_type', 'campaign_id', 'gift_prize', 'gift_stage', 'newsletter_optin', 'outcome']);

  function uuid() { return 'af_' + (window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2)); }
  function validId(v) { return typeof v === 'string' && /^[a-zA-Z0-9_-]{1,80}$/.test(v); }
  function readCookie(name) {
    try { var p = document.cookie.split('; ').find(function (x) { return x.indexOf(name + '=') === 0; }); return p ? decodeURIComponent(p.slice(name.length + 1)) : ''; } catch (e) { return ''; }
  }
  function saveConsent(value) {
    var domain = /(^|\.)afich\.com$/.test(location.hostname) ? '; Domain=.afich.com' : '';
    document.cookie = 'afich_analytics_consent=' + (value ? 'yes' : 'no') + '; Path=/; Max-Age=15552000; SameSite=Lax' + domain + (location.protocol === 'https:' ? '; Secure' : '');
  }
  function safePage(url) {
    try {
      var u = new URL(url), safe = new URL(u.origin + u.pathname);
      // Keep acquisition attribution, discard image URLs, names and all free-text parameters.
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_content', 'gclid', 'gbraid', 'wbraid'].forEach(function (key) {
        var value = u.searchParams.get(key);
        if (value && /^[a-zA-Z0-9 _.-]{1,200}$/.test(value)) safe.searchParams.set(key, value);
      });
      return safe.href;
    } catch (e) { return ''; }
  }
  function clean(params) {
    var out = {};
    Object.keys(params || {}).forEach(function (k) {
      if (!fields.has(k)) return;
      var v = params[k];
      if (typeof v === 'number' && Number.isFinite(v)) out[k] = Math.max(0, Math.min(v, 100000000));
      // Never accept free text, image URLs, emails or prompt fragments.
      else if (typeof v === 'string' && /^[a-zA-Z0-9_./-]{1,100}$/.test(v) && v.indexOf('://') < 0) out[k] = v;
    });
    return out;
  }
  function context() {
    if (!allowed || !/^\d+\.\d+$/.test(clientId) || !/^\d+$/.test(String(sessionId))) return null;
    if (!creationId) creationId = uuid();
    return { consent: true, client_id: clientId, session_id: String(sessionId), creation_id: creationId, surface: surface, mode: mode };
  }
  function childContext(target, origin, nonce) {
    try { target.postMessage({ type: 'AFICH_ANALYTICS_CONTEXT', nonce: nonce, allowed: allowed,
      context: context() }, origin); } catch (e) {}
  }
  function broadcast() { frames.forEach(function (f) { childContext(f.source, f.origin, f.nonce); }); }
  function flush() {
    if (!context() || embedded) return;
    var pending = queue; queue = [];
    pending.forEach(function (entry) { dispatch(entry[0], entry[1]); });
    broadcast();
  }
  function dispatch(name, params) {
    try { dispatchEvent(name, params); } catch (e) { /* Measurement must never break a customer action. */ }
  }
  function dispatchEvent(name, params) {
    if (!allowed || !events.has(name)) return;
    var p = Object.assign({ surface: surface, creation_mode: mode, creation_id: creationId || undefined }, clean(params));
    if (embedded) {
      if (trusted.indexOf(parentOrigin) >= 0) window.parent.postMessage({ type: 'AFICH_ANALYTICS_EVENT', name: name, params: p, nonce: parentNonce }, parentOrigin);
      return;
    }
    if (!context()) { if (queue.length < 50) queue.push([name, p]); return; }
    window.gtag('event', name, Object.assign(p, {
      send_to: MID, tracking_version: VERSION, event_source: 'browser',
      page_location: safePage(location.href), page_referrer: safePage(document.referrer),
      transport_type: 'beacon',
      ...(!/^(www\.)?afich\.com$|^edition\.afich\.com$/.test(location.hostname) ? { debug_mode: true } : {}),
    }));
  }
  function enableTag() {
    if (tagStarted || embedded) return;
    tagStarted = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    // Shopify retains ownership of the standard ecommerce events and advertising consent.
    window.gtag('consent', 'default', { analytics_storage: 'granted', ad_storage: 'denied',
      ad_user_data: 'denied', ad_personalization: 'denied' });
    window.gtag('js', new Date());
    window.gtag('config', MID, { send_page_view: false, allow_google_signals: false,
      allow_ad_personalization_signals: false, page_location: safePage(location.href),
      page_referrer: safePage(document.referrer) });
    if (!document.querySelector('script[data-afich-ga4]')) {
      var script = document.createElement('script'); script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + GOOGLE_TAG_LOADER;
      script.dataset.afichGa4 = '1'; document.head.appendChild(script);
    }
    window.gtag('get', MID, 'client_id', function (v) { if (/^\d+\.\d+$/.test(v || '')) clientId = v; flush(); });
    window.gtag('get', MID, 'session_id', function (v) { if (/^\d+$/.test(String(v || ''))) sessionId = String(v); flush(); });
  }
  function setConsent(value, remember) {
    var changed = allowed !== value; allowed = value === true;
    window['ga-disable-' + MID] = !allowed;
    if (tagStarted && !embedded) window.gtag('consent', 'update', { analytics_storage: allowed ? 'granted' : 'denied' });
    if (remember) saveConsent(allowed);
    if (!allowed) { queue = []; clientId = ''; sessionId = ''; broadcast(); return; }
    if (!tagStarted) enableTag();
    else if (!embedded) {
      window.gtag('get', MID, 'client_id', function (v) { clientId = v || ''; flush(); });
      window.gtag('get', MID, 'session_id', function (v) { sessionId = String(v || ''); flush(); });
    }
    if (changed) {
      dispatch('afich_surface_viewed', { entry_type: embedded ? 'iframe' : 'page' });
      if (step) dispatch('afich_step_viewed', { step: step });
    }
    broadcast();
  }
  function syncShopifyConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
      setConsent(privacy.analyticsProcessingAllowed() === true, true); return true;
    }
    return false;
  }
  function consentBanner() {
    if (document.getElementById('afich-analytics-consent')) return;
    var box = document.createElement('div'); box.id = 'afich-analytics-consent';
    box.setAttribute('role', 'region'); box.setAttribute('aria-label', 'Préférences de mesure d’audience');
    box.style.cssText = 'position:fixed;bottom:12px;left:12px;right:12px;max-width:520px;margin:auto;z-index:100000;background:#fffdf8;color:#25304b;border:1px solid #d8d4cb;border-radius:12px;padding:14px 16px;box-shadow:0 8px 30px #0002;font:13px/1.5 system-ui;text-align:left';
    box.innerHTML = '<div>Autoriser la mesure d’audience pour nous aider à améliorer l’atelier ? Vos photos et vos textes ne sont pas transmis à Google Analytics. <a href="https://afich.com/policies/privacy-policy" target="_blank" rel="noopener">Confidentialité</a></div><div style="display:flex;gap:10px;margin-top:10px"><button type="button" data-choice="no">Refuser</button><button type="button" data-choice="yes">Accepter</button></div>';
    box.querySelectorAll('button').forEach(function (b) {
      b.style.cssText = 'padding:8px 18px;background:#fff;border:1px solid #9c9c9c;border-radius:6px;color:#25304b;font:inherit;cursor:pointer';
      b.onclick = function () { setConsent(b.dataset.choice === 'yes', true); box.remove(); };
    });
    document.body.appendChild(box);
  }
  function ownedFrame(source) {
    return Array.from(document.querySelectorAll('iframe')).some(function (frame) { return frame.contentWindow === source; });
  }
  window.addEventListener('message', function (e) {
    if (trusted.indexOf(e.origin) < 0 || !e.data) return;
    var d = e.data;
    if (embedded && e.source === window.parent && d.type === 'AFICH_ANALYTICS_CONTEXT' && d.nonce === parentNonce) {
      parentOrigin = e.origin;
      var before = allowed; allowed = d.allowed === true;
      if (allowed && d.context) {
        clientId = d.context.client_id || ''; sessionId = String(d.context.session_id || '');
        if (!creationId && validId(d.context.creation_id)) creationId = d.context.creation_id;
      } else { clientId = ''; sessionId = ''; queue = []; }
      if (!before && allowed) { dispatch('afich_surface_viewed', { entry_type: 'iframe' }); if (step) dispatch('afich_step_viewed', { step: step }); }
      return;
    }
    if (embedded || !ownedFrame(e.source)) return;
    if ((d.type === 'AFICH_CREATE_REDIRECT' || d.type === 'AFICH_ORDER_COMPLETED') && validId(d.creationId)) {
      creationId = d.creationId; personalizedPage = true;
      try { sessionStorage.setItem('afich_tracking_handoff', JSON.stringify({ id: creationId, at: Date.now() })); } catch (err) {}
      broadcast();
    }
    if (d.type === 'AFICH_ANALYTICS_CONTEXT_REQUEST' && validId(d.nonce)) {
      var frame = frames.find(function (f) { return f.source === e.source; });
      if (!frame) { frame = { source: e.source, origin: e.origin, nonce: d.nonce }; frames.push(frame); }
      frame.nonce = d.nonce;
      childContext(e.source, e.origin, d.nonce);
    } else if (d.type === 'AFICH_ANALYTICS_EVENT' && frames.some(function (f) { return f.source === e.source && f.nonce === d.nonce; })) {
      dispatch(d.name, d.params);
    }
  });

  function operationFor(path, body) {
    if (/^\/api\/create-poster(?:-async)?$/.test(path)) return 'generation';
    if (/^\/api\/(atelier-edit|edit-image|regenerate-async|poster-edit-async|cdm-personalize-async)$/.test(path)) return 'edit';
    // The guided studio renders creations, alternatives and batched edits through one route.
    if (path === '/api/studio/render') return body && body.kind === 'edit' ? 'edit' : 'generation';
    return '';
  }
  window.fetch = function (input, options) {
    var url, next = options, operation = '', cart = false;
    try {
      url = new URL(typeof input === 'string' ? input : input.url, location.href);
      var internal = url.origin === location.origin || url.origin === 'https://edition.afich.com';
      operation = internal ? operationFor(url.pathname) : '';
      cart = url.origin === location.origin && /\/cart\/add(?:\.js)?$/.test(url.pathname);
      if (internal && url.pathname.indexOf('/api/') === 0 && options && typeof options.body === 'string') {
        var body = JSON.parse(options.body), ctx = context();
        operation = operationFor(url.pathname, body);
        if (ctx) next = Object.assign({}, options, { body: JSON.stringify(Object.assign({}, body, { _analytics: ctx })) });
        if (operation) dispatch('afich_' + operation + '_requested', { operation: operation });
      }
    } catch (e) { /* Preserve the original request if instrumentation cannot inspect it. */ }
    return nativeFetch(input, next).then(function (response) {
      if (operation && !response.ok) dispatch(response.status === 429 ? 'afich_quota_reached' : 'afich_error', {
        operation: operation, http_status: response.status, error_code: 'http_' + response.status,
      });
      if (cart) response.clone().json().then(function (data) {
        if (!response.ok || data.status >= 400) { dispatch('afich_cart_error', { http_status: response.status }); return; }
        var items = data.items || [data];
        // Only read the functional gift state after analytics consent. Never send its token/code/email.
        if (allowed) try {
          var gift = JSON.parse(localStorage.getItem('afich-october-2026') || 'null');
          if (gift && gift.expires > Date.now() && ['five','ten','twenty','half','poster'].includes(gift.gain)) {
            dispatch('afich_gift_cart_added', { campaign_id: 'october_2026', gift_prize: gift.gain,
              item_count: items.reduce(function (n, item) { return n + (Number(item.quantity) || 1); }, 0) });
          }
        } catch (e) {}
        items.forEach(function (item) {
          var id = item.properties && item.properties._afich_creation_id;
          if (validId(id)) dispatch('afich_cart_added', { creation_id: id, item_count: Number(item.quantity) || 1, product_variant: String(item.variant_id || item.id || '') });
        });
      }).catch(function () {});
      return response;
    }, function (error) {
      if (operation) dispatch('afich_error', { operation: operation, error_code: 'network' });
      throw error;
    });
  };

  window.AfichAnalytics = {
    version: VERSION, track: dispatch, context: context,
    startCreation: function (selectedMode) { creationId = uuid(); mode = selectedMode || 'lieu'; broadcast(); return creationId; },
    setCreation: function (id) { if (validId(id)) { creationId = id; broadcast(); } },
    getCreation: function () { if (!creationId) creationId = uuid(); return creationId; },
    setMode: function (value) { if (['lieu', 'perso', 'edit', 'text'].indexOf(value) >= 0) mode = value; },
    step: function (value) { step = value; dispatch('afich_step_viewed', { step: value }); },
  };
  (window.afichAnalyticsQueue || []).forEach(function (item) {
    if (item[0] === 'step') window.AfichAnalytics.step(item[1]);
    else dispatch(item[0], item[1]);
  });
  window.afichAnalyticsQueue = [];
  try {
    var given = new URLSearchParams(location.search).get('afich_creation_id');
    if (validId(given)) creationId = given;
    if (!creationId && personalizedPage) {
      var previous = JSON.parse(sessionStorage.getItem('afich_tracking_handoff') || 'null');
      if (previous && Date.now() - previous.at < 1800000 && validId(previous.id)) creationId = previous.id;
    }
    if (window.Shopify && location.pathname.indexOf('/products/votre-affiche-sur-mesure') === 0) {
      var handoff = JSON.parse(sessionStorage.getItem('afich_studio_creation') || 'null');
      if (handoff && Date.now() - handoff.createdAt < 1800000 && validId(handoff.creationId)) { creationId = handoff.creationId; mode = handoff.mode === 'perso' ? 'perso' : 'lieu'; }
    }
  } catch (e) {}

  function boot() {
    if (embedded) {
      var tries = 0;
      var requestContext = function () {
        if (trusted.indexOf(parentOrigin) >= 0) window.parent.postMessage({ type: 'AFICH_ANALYTICS_CONTEXT_REQUEST', nonce: parentNonce }, parentOrigin);
      };
      requestContext();
      var timer = setInterval(function () { requestContext(); if (++tries >= 20 || context()) clearInterval(timer); }, 500);
    } else if (window.Shopify) {
      if (!syncShopifyConsent()) {
        if (typeof window.Shopify.loadFeatures === 'function') window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { syncShopifyConsent(); });
        var checks = 0, privacyTimer = setInterval(function () { if (syncShopifyConsent() || ++checks > 30) clearInterval(privacyTimer); }, 1000);
      }
      document.addEventListener('visitorConsentCollected', syncShopifyConsent);
    } else {
      var consent = readCookie('afich_analytics_consent');
      if (consent === 'yes' || consent === 'no') setConsent(consent === 'yes', false);
      else consentBanner();
    }
    document.addEventListener('click', function (event) {
      var el = event.target.closest && event.target.closest('button[name="checkout"],input[name="checkout"],a[href^="/checkout"]');
      if (el) dispatch('afich_checkout_clicked', {});
    }, true);
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!window.Shopify || !form.action || form.action.indexOf('/cart/add') < 0 || !creationId) return;
      if (!personalizedPage && !form.querySelector('input[name="properties[_design]"]')) return;
      var hidden = form.querySelector('input[name="properties[_afich_creation_id]"]');
      if (!hidden) { hidden = document.createElement('input'); hidden.type = 'hidden'; hidden.name = 'properties[_afich_creation_id]'; form.appendChild(hidden); }
      hidden.value = creationId;
    }, true);
    var formStarted = false;
    document.addEventListener('input', function (event) {
      if (!formStarted && (surface === 'creator' || surface === 'atelier' || surface === 'guided_studio') && event.target.closest('form,.af-root')) {
        formStarted = true; dispatch('afich_form_started', { step: step });
      }
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden' && creationId) dispatch('afich_page_hidden', { step: step, duration_ms: Date.now() - started });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
